import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { getDefaultImage } from "../../utils/GeneralUtils";
import { SonicWorkData } from "../../common/classes/SonicWork";
import styles from "./Works.module.scss";
import WorkModal from "./WorkModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  works: Array<SonicWorkData>;
};
const Works: React.FC<Props> = ({ works }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [workNumber, setWorkNumber] = useState<number>(0);
  return (
    <>
      <div className={styles["works__container"]}>
        <Swiper
          modules={[Navigation]}
          className={styles["works__container-swiper"]}
          slidesPerView={"auto"}
          spaceBetween={16}
          navigation={{
            prevEl: `.${styles["works-prev"]}`,
            nextEl: `.${styles["works-next"]}`,
            disabledClass: `${styles["disabled"]}`,
          }}
        >
          {works.map((work, i) => (
            <SwiperSlide
              key={i}
              className={styles["works__container-swiper__item"]}
              onClick={() => {
                setWorkNumber(i);
                setIsOpen(true);
              }}
            >
              <div className={styles["imgBox"]}>
                <img
                  src={work.image ? work.image.large?.url : getDefaultImage()}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div
          className={`${styles["works__container-btn"]} ${styles["works-prev"]}`}
        >
          <FontAwesomeIcon icon={["fal", "arrow-left"]} />
        </div>
        <div
          className={`${styles["works__container-btn"]} ${styles["works-next"]}`}
        >
          <FontAwesomeIcon icon={["fal", "arrow-right"]} />
        </div>
      </div>
      {isOpen ? (
        <WorkModal
          works={works[workNumber]}
          handleClose={() => {
            setWorkNumber(0);
            setIsOpen(false);
          }}
        />
      ) : null}
    </>
  );
};

export default Works;
